mutation UnmapRevitValue(
    $id: ID!
) {
    unmapRevitValue(
        id: $id
    )
}
